import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import useStore from "../../features/store";
import Table from "../../components/common/table";
import moment from "jalali-moment";
import { analysisFeedbackTypeConverter } from "../../utils/Functions";
import Loading from "../../components/common/loading";

const DashboardMessages = () => {
  const [modelParams] = useSearchParams();
  const model = modelParams.get("model");

  const {
    messagesFeedbacks,
    messagesTickets,
    isLoadingMessages,
    fetchMessages,
  }: any = useStore();

  useEffect(() => {
    if (!messagesFeedbacks && model === "feedback") {
      fetchMessages("feedback");
    }

    if (!messagesTickets && model === "contact-us") {
      fetchMessages("contact_us");
    }
  }, [messagesFeedbacks, messagesTickets, model]);

  const TdComponent = ({ children }: any) => {
    return (
      <td className="whitespace-nowrap text-sm overflow-hidden">{children}</td>
    );
  };

  const TdLongComponent = ({ children }: any) => {
    return (
      <td className="text-sm overflow-hidden lg:max-w-[200px] whitespace-nowrap lg:whitespace-normal">
        {children}
      </td>
    );
  };

  const Feedbacks = () => {
    return (
      <Table
        header={["", "نوع", "نام کاربر", "تاریخ ثبت", "مشکلات ثبت شده", "پیام"]}
        body={messagesFeedbacks?.results?.map((feedback: any, idx: number) => (
          <tr className={`border-gray-100 bg-white`} key={idx}>
            <TdComponent>{idx + 1}</TdComponent>
            <TdComponent>
              <span
                className={`font-rokh font-[700] text-xs px-3 pt-[5px] pb-[2px] rounded ${
                  feedback.is_liked ? "bg-pr_green" : "bg-pr_red"
                }`}
              >
                {feedback.is_liked ? "مثبت" : "منفی"}
              </span>
            </TdComponent>
            <TdComponent>
              {feedback.creator?.first_name} {feedback.creator?.last_name}
            </TdComponent>
            <TdComponent>
              {moment(feedback.created_at).format("jYYYY/jMM/jDD")}
            </TdComponent>
            <TdComponent>
              {feedback.analysis_feedback_type?.map((type: string) =>
                analysisFeedbackTypeConverter(type)
              )}
            </TdComponent>
            <TdLongComponent>{feedback.feedback}</TdLongComponent>
          </tr>
        ))}
      />
    );
  };

  const Tickets = () => {
    return (
      <Table
        header={["", "نام کاربر", "موضوع", "شماره همراه", "ایمیل", "پیام"]}
        body={messagesTickets?.results?.map((message: any, idx: number) => (
          <tr className={`border-gray-100 bg-white`} key={idx}>
            <TdComponent>{idx + 1}</TdComponent>
            <TdComponent>
              {message.name} {message.family}
            </TdComponent>
            <TdComponent>{message.subject}</TdComponent>
            <TdComponent>{message.Phone_number}</TdComponent>
            <TdComponent>{message.email}</TdComponent>
            <TdLongComponent>{message.message}</TdLongComponent>
          </tr>
        ))}
      />
    );
  };

  return (
    <div className="my-10">
      <div className="breadcrumbs text-sm">
        <ul>
          <li>
            <Link to="/dashboard">داشبورد</Link>
          </li>
          <li className="font-[900]">
            {model === "feedback" ? "فیدبک‌ها" : "نظرات"}
          </li>
        </ul>
      </div>

      <h1 className="font-rokh font-[900] text-2xl my-6 text-center">
        {model === "feedback" ? "فیدبک‌های" : "نظرات"} بادی‌بان
      </h1>
      <div className="overflow-x-auto border rounded-lg">
        {isLoadingMessages ? (
          <Loading />
        ) : model === "feedback" ? (
          <Feedbacks />
        ) : (
          <Tickets />
        )}
      </div>
    </div>
  );
};

export default DashboardMessages;
